import styled from 'styled-components';

export const NavContainer = styled.nav`
    display: flex;
    flex-direction: row;
    justify-content: center;  
`;